import { StorageService } from '../storage/storage.service';
import { UtilsService } from './../utils/utils.service';
import { UserService } from '../user/user.service';
import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { ToastController, Platform } from '@ionic/angular';
import { Router } from '@angular/router';
import { map, retry, switchMap, tap, throwIfEmpty } from 'rxjs/operators';
import { Observable, BehaviorSubject, from, of } from 'rxjs';

import { User } from '../../models/user';
import { UserLoginCredentials, ChangePasswordCredentials, ResetPasswordCredentials } from './user-creds';
import { AuthResponse } from './auth-response';
import { environment as ENV } from '../../../environments/environment';
import { JwtHelperService } from '@auth0/angular-jwt';
import { AppAlertService } from '../app-alert/app-alert.service';
import { InitUserService } from 'src/app/@auth/init-user.service';
import { NbTokenService } from '@nebular/auth';

// import TimeAgo from "javascript-time-ago";
// Load locale-specific relative date/time formatting rules and labels.
// import en from "javascript-time-ago/locale/en";
// TimeAgo.addLocale(en);


// const helper = new JwtHelperService();
const TOKEN_KEY = 'ACCESS_TOKEN';
const REFRESH_KEY = 'REFRESH_TOKEN';
const TOKEN_EXP_KEY = 'TOKEN_EXPIRES_IN';

@Injectable({
  providedIn: 'root',
})

export class AuthService {

  // timeAgo = TimeAgo("en-US");
  // authState  = new BehaviorSubject(false);

  user: Observable<any> = null;
  state = new BehaviorSubject(null);

  // constructor(private httpClient: HttpClient, private storage: Storage) { }

  constructor(
    private httpClient: HttpClient,
    private helper: JwtHelperService,
    private router: Router,
    private platform: Platform,
    private userService: UserService,
    private utilsService: UtilsService,
    private storageService: StorageService,
    private alertController: AppAlertService,
    private initService: InitUserService,
    private tokenService: NbTokenService
    // public toastController: ToastController
    // private plt: Platform,
  ) {
  }

  loadUserInfo() {
    const isReady = from(this.platform.ready());

    this.user = isReady.pipe(switchMap(() => {
      return from(this.getAccessToken());
    }), map((token:any) => {
      if (!token) { return null; }
      this.state.next(this.helper.decodeToken(token));
      // let decodedUser = this.helper.decodeToken(token);
      // this.state.next(decodedUser);
      this.initService.initCurrentUser()
      return true;
    }));
  }

  /** TODO: add summary */
  async checkToken(callback?: Function) {
    this.storageService.get(TOKEN_KEY).then(async token => {

      let refresh = await this.storageService.get(REFRESH_KEY);
      refresh;
      if (token) {
        const decoded = this.helper.decodeToken(token);
        const isExpired = this.helper.isTokenExpired(token);

        if (!isExpired) {
          this.user = decoded;
          this.state.next(true);
          if (callback) callback(true)
        } else {
          // this.storageService.remove(TOKEN_KEY);
          // // this.storageService.remove(REFRESH_KEY);
          // this.storageService.remove(TOKEN_EXP_KEY);
          this.getRefreshToken().then((refreshToken) => {
            this.refreshToken(refreshToken).then(res=>{

                // console.log(res);
                if (res.token) {
                  this.storageService.set(TOKEN_KEY, res.token.access_token);
                  this.storageService.set(REFRESH_KEY, res.token.refresh_token);
                  this.storageService.set(TOKEN_EXP_KEY, res.token.expires_in);
                  this.state.next(true);
                  this.initService.initCurrentUser()
                  callback(true)

                  return true;
                }
                return false;
            }).catch(err=>{
              callback(false)
            })

            if (refreshToken == null) callback(false)
          })
          .catch(err=>{
            // this.storageService.remove(REFRESH_KEY);
            console.error(err)
            callback(false)
          })
        }
      }
      else {
        callback(false)
      }
    });
  }

  getAccessToken() {
    return this.storageService.get(TOKEN_KEY);
  }

  getTokenExpiryDate() {
    return this.storageService.get(TOKEN_EXP_KEY);
  }

  async getRefreshToken() {
    let token = await this.storageService.get(TOKEN_KEY)
    let refresh = await this.storageService.get(REFRESH_KEY);
    let exp = await this.storageService.get(TOKEN_EXP_KEY);

    return refresh;
  }


  isAuthenticated(): boolean {
    return this.state.value;
  }

  // POST Request to /api/auth/sign-up
  // attempts to register the user
  async signup(user: User): Promise<any> {
    let loader = await this.alertController.showLoader();

    return new Promise ((resolve,reject)=>{

      let headers = new HttpHeaders().set('X-Skip-Interceptor', '');
      let options:any = {headers: headers}

      this.utilsService.makePostRequest(`auth/sign-up`, user, options)
        .then( async (res) => {
          if (res.token) {
            await this.storageService.set(TOKEN_KEY, res.token.access_token);
            await this.storageService.set(REFRESH_KEY, res.token.refresh_token);
            await this.storageService.set(TOKEN_EXP_KEY, res.token.expires_in);
            this.state.next(true);
            await this.initService.initCurrentUser().then(async ()=>{
              await loader.dismiss()
              resolve(true)
            })
          }
          else {
            this.router.navigateByUrl('login');
          }
        }).catch((e)=>{
          let userExistsMsg = "User already exists";
          if (e.error == userExistsMsg || e.error.error == userExistsMsg){
            this.alertController.showErrorAlert("Email already taken.")
          }
          else {
            this.alertController.showErrorAlert((e.error.error || e.error) ? "Registration error: " + (e.error.error ?? e.error) : "registration error: check input")
          }
          loader.dismiss()
          reject(e)
        })
    })

  }


  // POST Request to /api/auth/login
  // attempts to login the user
  async login(userCreds: UserLoginCredentials): Promise<boolean> {
    let loader = await this.alertController.showLoader();

    let headers = new HttpHeaders().set('X-Skip-Interceptor', '');
    let options:any = {headers: headers}

    return this.utilsService.makePostRequest(`auth/login`, userCreds, options).then(
    (res: any) => {
        // console.log(res);
        if (res.token) {
          this.storageService.set(TOKEN_KEY, res.token.access_token);
          this.storageService.set(REFRESH_KEY, res.token.refresh_token);
          this.storageService.set(TOKEN_EXP_KEY, res.token.expires_in);
          this.state.next(true);
          this.initService.initCurrentUser().then(async ()=>{
            loader.dismiss()
          })

          return true;
        }
        return false;
    }).catch(err=>{
      loader.dismiss();
      this.alertController.showErrorAlert(err?.error?.error ?? err?.error ?? err)

      return false;
    })
  }


  // POST Request to /api/auth/logout
  // attempts to logout an authenticated user
  async logout() {
    this.httpClient.post(`${this.utilsService.getApi()}/auth/logout`, {});
    await this.storageService.remove(TOKEN_KEY);
    await this.storageService.remove(REFRESH_KEY);
    await this.storageService.remove(TOKEN_EXP_KEY);
    this.router.navigate(['/login']);
  }


  // POST Request to /api/auth/change-password
  // attempts to change the password of an authenticated user
  // this action logs out the current user
  changePassword(passwords: ChangePasswordCredentials) {
    return this.httpClient.post(`${this.utilsService.getApi()}/auth/change-password`, passwords).pipe(
      tap(async (res: AuthResponse) => {
        await this.logout();
        // todo: add logic => display message, return to login page
      })
    );
  }


  // POST Request to /api/auth/forgot-password
  // sends a request for a reset password token/code to be sent
  // via email/phone
  async forgotPassword(emailOrPhone: string) {

    let headers = new HttpHeaders().set('X-Skip-Interceptor', '');
    let options:any = {headers: headers}

    let loader = await this.alertController.showLoader()
    return this.httpClient.post(`${this.utilsService.getApi()}/auth/forgot-password`, emailOrPhone, options).toPromise().then(async res=>{
      this.alertController.showSuccessAlert("Reset code sent")
      await loader.dismiss()
      this.router.navigate(['/reset-password']);
    }).catch(async e=>{
      await loader.dismiss()
      if (e?.data?.error == "There is no defined email in the system."){
        this.alertController.showErrorAlert("A user with this email doesn't exist")
      }
      else {
        this.alertController.showErrorAlert("Error in sending reset code to this email")
      }
    })
  }

  // POST Request to /api/auth/reset-password
  // attempts to set a new password for a user using a reset
  // password token/code
  async resetPassword(creds: ResetPasswordCredentials) {

    let headers = new HttpHeaders().set('X-Skip-Interceptor', '');
    let options:any = {headers: headers}

    let loader = await this.alertController.showLoader()
    return this.httpClient.post(`${this.utilsService.getApi()}/auth/reset-password`, creds, options).toPromise().then( async(res)=>{
      await loader.dismiss()
      this.alertController.showSuccessAlert("Password reset successfully")
      this.router.navigate(['/login']);
    }).catch(async e=>{
      await loader.dismiss()
      this.alertController.showErrorAlert("Error in resetting password")
    })
  }

  // POST Request to /api/auth/request-password
  // sends a request for a new password to be sent via email/phone
  requestPassword(emailOrPhone: string) {
    let headers = new HttpHeaders().set('X-Skip-Interceptor', '');
    let options:any = {headers: headers}
    return this.httpClient.post(`${this.utilsService.getApi()}/auth/request-password`, emailOrPhone, options).pipe(
      tap(async (res) => {
        // display message, return to login page
      })
    );
  }

  // POST Request to /api/auth/refresh-token
  // sends a request for a new auth token
  refreshToken(payload: any) {
    return this.utilsService.makePostRequest(`auth/refresh-token`, {token: String(payload)})
  }

  exchangeGoogleCodeForToken(code: string): Observable<boolean> {
    if (!code || code.trim() === '') {
      console.error('Authorization code is empty or invalid');
      this.alertController.showErrorAlert('Authorization code is empty or invalid');
      return of(false); // Return an observable with false if the code is invalid
    }
    const strapiUrl = `${this.utilsService.getApi()}/auth/google/callback`; // Strapi endpoint for Google auth

    return this.httpClient
      .get(`${strapiUrl}?access_token=${code}`)
      .pipe(
        map((response: any) => {
          const token = response.jwt; // Extract the token from the response
          this.storageService.set(TOKEN_KEY, token); // Store the token using StorageService
          this.tokenService.set(token); // Set the token in Nebular's token service
          this.state.next(true);
          this.initService.initCurrentUser();
          return true;
        }),
        throwIfEmpty(() => new Error('No token received from Strapi'))
      );
  }
}
